import React from 'react'
import PropTypes from 'prop-types'
import { Container, Tooltip } from '@/components/__UI'
import { useMenuContext } from '../Header/context/context'

const PageWrapper = ({title, tooltipText, children}) => {
  const {closeSubmenu} = useMenuContext()

  return (
    <Container onMouseOver={closeSubmenu}>
      {title && <h1 data-testid="pageWrapperTitle"> {title} {tooltipText && <Tooltip text={tooltipText} />}</h1>}
      {children}
    </Container>
  )
}

PageWrapper.propTypes = {
  title: PropTypes.string,
  tooltipText: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ])
}

export default PageWrapper
